var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-close" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("a-spin", {
              attrs: { size: "large", tip: _vm.$t("auto.loading") },
            }),
          ],
          1
        )
      : _vm.tasks && _vm.tasks.length > 0
      ? _c(
          "div",
          { staticClass: "task-grid" },
          _vm._l(_vm.tasks, function (task) {
            return _c("div", { key: task._id, staticClass: "task-card" }, [
              task.attachments.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "task-card__image",
                      on: {
                        click: function ($event) {
                          return _vm.view(task)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            task.attachments[0].v2Format &&
                            task.attachments[0].cdnUrl
                              ? task.attachments[0].cdnUrl
                              : "https://static.supsis.live/" +
                                (task.attachments[0].path +
                                  task.attachments[0]._id) +
                                "." +
                                task.attachments[0].ext,
                          alt: _vm.$t("message.attachmentThumbnailAlt"),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "task-card__content",
                  on: {
                    click: function ($event) {
                      return _vm.view(task)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "task-card__header" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "task-card__title",
                          on: {
                            click: function ($event) {
                              return _vm.view(task)
                            },
                          },
                        },
                        [_vm._v(_vm._s(task.title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-popover",
                        {
                          attrs: {
                            overlayClassName: "task-more-options",
                            trigger: "click",
                            placement: "bottomRight",
                            visible: task.showPopover,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleInnerClick($event, task)
                            },
                            visibleChange: function ($event) {
                              return _vm.handlePopoverChange($event, task)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return _vm._l(
                                    _vm.filteredActions,
                                    function (action, index) {
                                      return _c("div", { key: index }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "task-card__action",
                                            on: {
                                              click: function ($event) {
                                                return _vm.runAction(
                                                  action.action,
                                                  task
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v(_vm._s(action.icon))]
                                            ),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(action.text) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ])
                                    }
                                  )
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "task-card__more material-icons" },
                            [_vm._v("more_vert")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task-card__tags" },
                    _vm._l(task.tags, function (tag) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: tag.name, placement: "top" },
                              expression:
                                "{ content: tag.name, placement: 'top' }",
                            },
                          ],
                          key: tag._id,
                          staticClass: "task-card__tag",
                          style: _vm.getTagStyle(tag.color),
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(tag.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "task-card__details" }, [
                    _c(
                      "div",
                      { staticClass: "task-card__users" },
                      [
                        _vm._l(
                          _vm.getAssigneesUserId(task).slice(0, 2),
                          function (userId) {
                            return _c("Avatar", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                    content:
                                      _vm.users[userId] &&
                                      _vm.users[userId].email,
                                  },
                                  expression:
                                    "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                content: users[userId] && users[userId].email,\n                            }",
                                },
                              ],
                              key: userId,
                              attrs: {
                                size: 25,
                                src:
                                  _vm.users[userId] &&
                                  _vm.users[userId].gravatar,
                                username:
                                  _vm.users[userId] && _vm.users[userId].name,
                              },
                            })
                          }
                        ),
                        _vm._v(" "),
                        _vm.getAssigneesUserId(task).length > 2
                          ? _c(
                              "span",
                              { staticClass: "task-card__users-more" },
                              [
                                _vm._v(
                                  "\n                            +" +
                                    _vm._s(
                                      _vm.getAssigneesUserId(task).length - 2
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "task-card__priority" },
                      [
                        _c(_vm.getPriorityIcon(task.priority), {
                          tag: "component",
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "task-card__meta" }, [
                    (task.subTasks || []).length > 0
                      ? _c("div", { staticClass: "task-card__meta-item" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("account_tree"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getCompletedParentTaskCount(task)) +
                              "/" +
                              _vm._s((task.subTasks || []).length) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    task.checklist.length > 0
                      ? _c("div", { staticClass: "task-card__meta-item" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("library_add_check"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getCompletedChecklistCount(task)) +
                              "/" +
                              _vm._s(task.checklist.length) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ])
          }),
          0
        )
      : _vm.tasks && _vm.tasks.length === 0
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "justify-content": "center",
              height: "500px",
              "align-content": "center",
              "align-items": "center",
            },
          },
          [
            _c("NotDataIcon", {
              staticStyle: { width: "200px", height: "200px" },
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticStyle: {
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  "font-size": "20px",
                  "margin-top": "24px",
                  "margin-left": "20px",
                },
              },
              [_vm._v("\n            Kapatılmış Task Bulunamadı\n        ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }